<div class="position-relative">
  @if (isLoading) {
    <loader [config]="{ type: 'spinner', overlay: true, size: 'md' }"></loader>
  }

  <div class="d-flex justify-content-between align-items-center mb-4">
    <p class="mb-0 text-secondary">Instalments generated from the linked proposal's payment conditions.</p>
    <button class="btn btn-outline-primary" type="button" [disabled]="isExporting" (click)="exportExcel()">
      <i class="bi bi-file-earmark-spreadsheet me-1"></i>Export Excel
    </button>
  </div>

  <div class="table-responsive">
    <table class="table finance-table">
      <thead>
        <tr>
          <th>Instalment</th>
          <th>Amount</th>
          <th>Due Date</th>
          <th>Paid Date</th>
          <th>Bank Received</th>
          <th>Reference</th>
          <th>Note</th>
          <th>Attachment</th>
          <th class="text-center">Send</th>
          <th>Sent Date</th>
          <th>Status</th>
          @if (canModify) {
            <th class="text-center">Actions</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (invoice of invoices; track invoice.projectInvoiceId) {
          <tr [class.finance-row-overdue]="isOverdue(invoice)">
            <td>
              <span class="fw-semibold">{{ invoice.instalmentTypeName }}</span>
              <span class="finance-subtext">{{ invoice.percent }}%</span>
            </td>
            <td class="finance-amount fw-semibold">{{ invoice.amount | currency: currency }}</td>
            <td [class.finance-date-overdue]="isOverdue(invoice)" class="text-nowrap">
              {{ formatDate(invoice.dueDate) }}
            </td>
            <td class="text-nowrap">{{ formatDate(invoice.paidDate) }}</td>
            <td>{{ invoice.bankReceived || '—' }}</td>
            <td>{{ invoice.reference || '—' }}</td>
            <td>{{ invoice.note || '—' }}</td>
            <td>
              @if (invoice.attachment) {
                <a href="javascript:void(0);" class="text-decoration-none" (click)="openAttachment(invoice)"
                  [title]="'Download ' + invoice.attachment.fileNameOriginal">
                  <i class="fa fa-solid fa-paperclip me-1"></i>{{ invoice.attachment.fileNameOriginal }}
                </a>
              } @else {
                —
              }
            </td>
            <td class="text-center">
              <div class="btn-group" [ngbTooltip]="sendTooltip(invoice)">
                <button type="button" class="btn btn-sm btn-action btn-primary"
                  [disabled]="!canSend(invoice)" (click)="confirmSend(invoice)">
                  <i class="fa fa-paper-plane"></i>
                </button>
              </div>
            </td>
            <td class="text-nowrap">
              {{ formatDate(invoice.sentDate, true) }}
            </td>
            <td>
              <span [class]="statusClass(invoice.status)">{{ statusLabel(invoice.status) }}</span>
            </td>
            @if (canModify) {
              <td class="text-center">
                <div class="btn-group">
                  <button type="button" class="btn btn-sm btn-action btn-primary" ngbTooltip="Edit instalment"
                    (click)="editInstalment(invoice)">
                    <i class="fa fa-edit"></i>
                  </button>
                </div>
              </td>
            }
          </tr>
        }
        @if (invoices.length === 0 && !isLoading) {
          <tr>
            <td [attr.colspan]="canModify ? 12 : 11" class="text-center text-muted">No instalments available</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <p class="finance-footnote">
    Rows are generated automatically from the linked Proposal's payment conditions — no manual add/delete on this list.
  </p>
</div>
